<template>
  <v-container class="select-name">
    <span class="fibl-headline">{{ $t('projectName.headline') }}</span>
    <p>{{ $t('projectName.subtext') }}</p>
    <v-text-field
      class="project-name-input"
      label="Name"
      hide-details="auto"
      v-model="name"
      :hint="hint"
      maxlength="255"
      counter
    ></v-text-field>
  </v-container>
</template>

<script>
import { nameCheck } from "@/main.js";
import { mapState } from "vuex";

export default {
  props: ["selectedRegions"],
  
  data() {
    return {
      name: "",
      hint: null,
    };
  },

  mounted() {
    this.suggestName();
    this.$emit("changed", this.name);
  },
  
  computed: {
    ...mapState(["projects"]),
  },

  methods: {
    suggestName() {
      let i;
      let displayNames = 2;

      for (i = 0; i < this.selectedRegions.length; i++) {
        if (this.selectedRegions.length === 1) {
          this.name = this.selectedRegions[0]['name_'+this.$i18n.locale];
        } else if (i < displayNames - 1) {
          this.name += this.selectedRegions[i]['name_'+this.$i18n.locale] + "/";
        } else {
          this.name += this.selectedRegions[i]['name_'+this.$i18n.locale];
        }
      }

      if (this.selectedRegions.length > displayNames) {
        let r = this.selectedRegions.length - displayNames;
        this.name += " (+ " + r.toString() + " weitere)";
      }

      let searchSpace = [];
      this.projects.forEach((p) => {
        searchSpace.push(p.name);
      });

      if (searchSpace.includes(this.name)) {
        this.name = nameCheck(this.name, searchSpace);
        this.$emit("changed", this.name);
      }
    },
  },

  watch: {
    name() {
      let searchSpace = [];
      this.projects.forEach((p) => {
        searchSpace.push(p.name);
      });

      if (searchSpace.includes(this.name.trim())) {
        this.hint = `Name "${this.name.trim()}" ${this.$i18n.t('projectName.hint.nameTaken')}`;
        this.$emit("changed", this.name, false);
      } else if (this.name.length < 1) {
        this.hint = this.$i18n.t('projectName.hint.nameEmpty');
        this.$emit("changed", this.name, false);
      } else {
        this.hint = null;
        this.$emit("changed", this.name, true);
      }
    },
  },
};
</script>
